import {Injectable} from '@angular/core';
import {Constant} from "../common/constant";
import {DataService} from "../common/service/data.service";
import { LocalStorageService, SessionStorageService } from 'ngx-webstorage';
import { HttpClient } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import { map } from 'rxjs/operators';
import { Dispatcher, StorePermission } from '../state';

@Injectable({ providedIn: 'root' })
export class AuthService {

  constructor(
    private http: HttpClient,
    private dispatcher: Dispatcher,
    private dataService:DataService,
    private localStorage: LocalStorageService, 
    private sessionStorage: SessionStorageService
  ) {}

  login(data) {
    return this.http.post(environment.urlBackEnd + Constant.api_auth_sign_in,data)
    .pipe(map((res: any) => {
      if (!res.data.mustLogin2Steps) {
        let status = res.data.profile.status;
        //Check status user is pending
        if (status !== Constant.status_user_pending) {
          //Save infor user
          this.dataService.token = res.data.tokenType + " " + res.data.accessToken;
          this.localStorage.store('TOKEN', this.dataService.token);
          this.sessionStorage.store('TOKEN', this.dataService.token);
          this.localStorage.store('PERMISSION', res.data.foResources);
          this.sessionStorage.store('PERMISSION', res.data.foResources);
          this.dispatcher.fire(new StorePermission(res.data.foResources));
        }
      }
      return res;
    }))
  }
  clear() {
    this.localStorage.store('TOKEN', '');
    this.sessionStorage.store('TOKEN', '');
  }
  confirmOTP(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_auth_sign_in_confirm, body);
  }
  forgotPassword(data) {
    return new Promise<boolean>((resolve, reject) =>{
      this.http.post(environment.urlBackEnd + Constant.api_auth_forgot_pass,data)
        .subscribe( (res: any)=>{
          if (res.status === Constant.success_code) {
              resolve(true)
          }
        })
    })
  }
  resendOTP(body) {
    return this.http.post(environment.urlBackEnd + Constant.api_user_check_exists_name, body);
  }
}
